<template>
  <el-dialog
    title="更多设置"
    :visible.sync="dialogVisible"
    width="470px"
    :close-on-click-modal="false"
    custom-class="more-setting-dialog"
    :before-close="handleClose"
  >
    <div ref="box" class="search-box">
      <el-scrollbar style="height: calc(100vh - 263px)">
        <div style="padding: 0 15px">
          <el-form
            :label-position="labelPosition"
            label-width="100px"
            ref="formSearch"
            :model="formSearch"
          >
            <el-form-item label="包含全部关键词" prop="allKey">
              <el-input
                type="textarea"
                rows="3"
                v-model="formSearch.allKey"
                placeholder="请输入关键词"
            /></el-form-item>
            <div v-if="formSearch.industryTypeId !== '1'">
              <el-form-item label="包含任意关键词" prop="anyKey">
                <el-input
                  v-model="formSearch.anyKey"
                  placeholder="请输入关键词"
                />
              </el-form-item>
              <el-form-item label="不包含的关键词" prop="nokeyword">
                <el-input
                  v-model="formSearch.exceptKey"
                  placeholder="请输入关键词"
                />
              </el-form-item>
            </div>
            <el-form-item label="检索范围" prop="industryTypeId">
              <el-radio-group v-model="formSearch.industryTypeId">
                <el-radio style="margin-right: 20px" label="0"
                  >新闻素材库</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <div v-if="formSearch.industryTypeId !== '1'">
              <el-form-item
                label="检索方式"
                prop="searchResultType"
                v-if="formSearch.industryTypeId === '0'"
              >
                <el-radio-group v-model="formSearch.searchResultType">
                  <el-radio
                    :label="'precise'"
                    @click.native.prevent="handleRadio('precise')"
                    >精准检索</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item label="日期范围" prop="time">
                <div class="dateType">
                  <div
                    v-for="(item, index) in dateTypeList"
                    :class="{ active: index === dataType }"
                    :key="item"
                    @click="changeDate(item, index)"
                  >
                    {{ item }}
                  </div>
                </div>
                <el-date-picker
                  size="small"
                  v-model="formSearch.time"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                  style="width: 100%"
                  value-format="yyyy-MM-dd"
                />
              </el-form-item>
              <el-form-item label="检索位置" prop="searchRange">
                <el-radio-group v-model="formSearch.searchRange">
                  <el-radio :label="''">全文</el-radio>
                  <el-radio :label="'title'">标题</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- <el-form-item label="检索方式" prop="searchResultType">
                <el-radio-group v-model="formSearch.searchResultType">
                  <el-radio label="0">精准检索</el-radio>
                  <el-radio label="-1">模糊检索</el-radio>
                </el-radio-group>
              </el-form-item> -->
              <el-form-item label="地域选择 （默认全部）" prop="cityid">
                <div style="position: relative">
                  <el-button
                    size="mini"
                    style="
                      position: absolute;
                      right: 0px;
                      top: -40px;
                      padding: 5px;
                    "
                    @click="clearCity"
                    >清空选项</el-button
                  >
                  <div class="choosedcontent">
                    <el-popover
                      placement="right"
                      width="400"
                      trigger="click"
                      popper-class="my-el-popover"
                      ref="popover"
                    >
                      <div class="addcity" slot="reference">
                        <p v-if="SelectedCityList.length == 0">点击选择城市</p>
                        <el-scrollbar
                          style="height: 150px; position: absolute; top: 0%"
                        >
                          <ul v-if="SelectedCityList.length != 0">
                            <li
                              v-for="item in SelectedCityList"
                              :key="item.cityID"
                            >
                              <p>
                                <span>{{ item.city }}</span>
                                <span
                                  style="margin-left: 6px"
                                  @click.stop="removeCity(item)"
                                  ><i class="el-icon-circle-close"></i
                                ></span>
                              </p>
                            </li>
                          </ul>
                        </el-scrollbar>
                      </div>
                      <div class="citylist">
                        <h3>地区选择</h3>
                        <ul class="oneCity" v-if="isShowlevelCity == false">
                          <li
                            v-for="(item, index) in onelevelCity"
                            :key="item.provinces"
                            @click="chooseOneCity(item, index)"
                          >
                            <a
                              :class="{ chooseactive: item.seleted == true }"
                              >{{ item.name }}</a
                            >
                          </li>
                        </ul>
                        <div v-if="isShowlevelCity == true">
                          <ul class="twoCity">
                            <li
                              v-for="(item, index) in twolevelCity"
                              :key="item.cityID"
                              @click="chooseTwoCity(item, index)"
                            >
                              <a
                                :class="{ chooseactive: item.seleted == true }"
                                >{{ item.city }}</a
                              >
                            </li>
                          </ul>
                          <div class="btn-city">
                            <el-button size="mini" @click="addAllCity"
                              >全部</el-button
                            >
                            <el-button size="mini" @click="backuplevel"
                              >返回上一级</el-button
                            >
                          </div>
                        </div>
                      </div>
                    </el-popover>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="范围选择 （默认全部）" prop="cityid">
                <div style="position: relative">
                  <el-button
                    size="mini"
                    style="
                      padding: 5px;
                      position: absolute;
                      right: 0px;
                      top: 8px;
                      z-index: 2;
                    "
                    @click="clearRange(activeName)"
                    >清空</el-button
                  >
                  <el-tabs v-model="activeName">
                    <el-tab-pane label="媒体" name="first">
                      <div class="choosedcontent">
                        <el-popover
                          placement="right"
                          width="400"
                          trigger="click"
                          popper-class="my-el-popover"
                          ref="popover"
                        >
                          <div class="addIncludeRange" slot="reference">
                            <p v-if="SelectedmediumRangeList.length == 0">
                              点击选择媒体
                            </p>
                            <el-scrollbar
                              style="height: 150px; position: absolute; top: 0%"
                            >
                              <ul v-if="SelectedmediumRangeList.length != 0">
                                <li
                                  v-for="item in SelectedmediumRangeList"
                                  :key="item.mediaid"
                                >
                                  <p>
                                    <span>{{
                                      item.name + "[" + item.typename + "]"
                                    }}</span>
                                    <span
                                      style="margin-left: 6px"
                                      @click.stop="
                                        removeMedium(item, 'mediumRange')
                                      "
                                      ><i class="el-icon-circle-close"></i
                                    ></span>
                                  </p>
                                </li>
                              </ul>
                            </el-scrollbar>
                          </div>
                          <div class="mediumList">
                            <h3>媒体选择（支持最多50个媒体）</h3>
                            <div style="padding: 10px 20px 15px 20px">
                              <div class="medium-search">
                                <el-input
                                  v-model="mediumSearchKey"
                                  placeholder="搜索您想要的媒体名称"
                                ></el-input
                                ><el-button @click="searchMedium('mediumRange')"
                                  >搜索</el-button
                                >
                              </div>
                              <ul
                                class="result-choosedmedium"
                                ref="resultmedium"
                                v-loading="Mediumload"
                                element-loading-text="拼命加载中"
                              >
                                <el-scrollbar style="height: 498px">
                                  <li
                                    v-for="item in mediumRangeList"
                                    :key="item.mediaid"
                                    @click="choosedmedium(item, 'mediumRange')"
                                  >
                                    <a>{{
                                      item.name + "[" + item.typename + "]"
                                    }}</a>
                                  </li>
                                </el-scrollbar>
                              </ul>
                            </div>
                          </div>
                        </el-popover>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="数据源" name="second">
                      <div class="choosedcontent">
                        <el-popover
                          placement="right"
                          width="400"
                          trigger="click"
                          popper-class="my-el-popover"
                          ref="popover"
                        >
                          <div class="addIncludeRange" slot="reference">
                            <p v-if="SelectedDatasourceList.length == 0">
                              点击选择数据源
                            </p>
                            <el-scrollbar
                              style="height: 150px; position: absolute; top: 0%"
                            >
                              <ul v-if="SelectedDatasourceList.length != 0">
                                <li
                                  v-for="item in SelectedDatasourceList"
                                  :key="item.mediaid"
                                >
                                  <p>
                                    <span>{{
                                      item.name + "[" + item.typename + "]"
                                    }}</span>
                                    <span
                                      style="margin-left: 6px"
                                      @click.stop="
                                        removeMedium(item, 'dataSource')
                                      "
                                      ><i class="el-icon-circle-close"></i
                                    ></span>
                                  </p>
                                </li>
                              </ul>
                            </el-scrollbar>
                          </div>
                          <div class="mediumList">
                            <h3>数据源选择（支持最多50个数据源）</h3>
                            <div style="padding: 10px 20px 15px 20px">
                              <div class="medium-search">
                                <el-select
                                  v-model="groupvalue"
                                  style="width: 120px; margin-right: 10px"
                                >
                                  <el-option
                                    v-for="item in groupList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                  >
                                  </el-option>
                                </el-select>
                                <el-input
                                  v-model="datasourceSearchKey"
                                  placeholder="搜索数据源名称或者URL"
                                ></el-input
                                ><el-button @click="searchMedium('dataSource')"
                                  >搜索</el-button
                                >
                              </div>
                              <ul
                                class="result-choosedmedium"
                                ref="datasource"
                                v-loading="datasourceload"
                                element-loading-text="拼命加载中"
                              >
                                <el-scrollbar style="height: 498px">
                                  <li
                                    v-for="item in datasourceList"
                                    :key="item.mediaid"
                                    @click="choosedmedium(item, 'dataSource')"
                                  >
                                    <a>{{
                                      item.name + "[" + item.typename + "]"
                                    }}</a>
                                  </li>
                                </el-scrollbar>
                              </ul>
                            </div>
                          </div>
                        </el-popover>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="信源" name="third">
                      <div class="choosedcontent">
                        <el-popover
                          placement="right"
                          width="400"
                          trigger="click"
                          popper-class="my-el-popover"
                          ref="popover"
                        >
                          <div class="addIncludeRange" slot="reference">
                            <p v-if="SelectedInfosourceList.length == 0">
                              点击选择信源
                            </p>
                            <el-scrollbar
                              style="height: 150px; position: absolute; top: 0%"
                            >
                              <ul v-if="SelectedInfosourceList.length != 0">
                                <li
                                  v-for="item in SelectedInfosourceList"
                                  :key="item.customSourceID"
                                >
                                  <p>
                                    <span>{{
                                      item.customSourceName +
                                      "[" +
                                      item.createUserName +
                                      "]"
                                    }}</span>
                                    <span
                                      style="margin-left: 6px"
                                      @click.stop="
                                        removeMedium(item, 'infosource')
                                      "
                                      ><i class="el-icon-circle-close"></i
                                    ></span>
                                  </p>
                                </li>
                              </ul>
                            </el-scrollbar>
                          </div>
                          <div class="mediumList">
                            <h3>信源选择（支持最多50个数信源）</h3>
                            <div style="padding: 10px 20px 15px 20px">
                              <ul
                                class="result-choosedmedium"
                                ref="infosource"
                                v-loading="infosourceload"
                                element-loading-text="拼命加载中"
                              >
                                <el-scrollbar style="height: 498px">
                                  <li
                                    v-for="item in infosourceList"
                                    :key="item.customSourceID"
                                    @click="choosedmedium(item, 'infosource')"
                                  >
                                    <a>{{
                                      item.customSourceName +
                                      "[" +
                                      item.createUserName +
                                      "]"
                                    }}</a>
                                  </li>
                                </el-scrollbar>
                              </ul>
                            </div>
                          </div>
                        </el-popover>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </el-form-item>
              <el-form-item label="原发布来源" prop="releaseSource">
                <el-input v-model="formSearch.releaseSource"></el-input>
              </el-form-item>
              <el-form-item label="来源类型" prop="source">
                <el-checkbox
                  v-model="AllcheckSource"
                  label="全部"
                  @change="handlerAllcheck('source')"
                ></el-checkbox>
                <!-- <el-checkbox
                  v-model="formSearch.tagSourceIsAnd"
                  label="切换详细"
                  @change="handlerSourceDetails"
                  style="position: absolute; right: 10px; top: -37px"
                >
                  切换详细
                  <el-tooltip
                    :content="'勾选当前选项，来源类型将切换至详细类型'"
                    placement="top"
                    effect="light"
                  >
                    <i class="el-icon-warning-outline"></i>
                  </el-tooltip>
                </el-checkbox> -->
                <el-checkbox-group
                  v-if="!this.formSearch.tagSourceIsAnd"
                  v-model="formSearch.groupArticletypes"
                  @change="handleSourceSelected"
                >
                  <el-checkbox
                    v-for="item in sourceList"
                    :key="item.id"
                    :label="item.value"
                  >
                    {{ item.name }}
                  </el-checkbox>
                </el-checkbox-group>
                <el-checkbox-group
                  v-else
                  v-model="formSearch.articletypes"
                  @change="handleSourceDetailSelected"
                >
                  <el-checkbox
                    v-for="item in sourceDetailsList"
                    :key="item.id"
                    :label="item.value"
                  >
                    {{ item.name }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="分类" prop="classify">
                <el-checkbox
                  v-model="Allcheck"
                  label="全部"
                  @change="handlerAllcheck('classify')"
                ></el-checkbox>
                <el-checkbox-group
                  v-model="classifyCheckList"
                  @change="handleClassifySelected"
                >
                  <el-checkbox
                    v-for="item in classifyList"
                    :key="item.id"
                    :label="item.description"
                  >
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="原创/转载" prop="original">
                <el-radio-group v-model="origin">
                  <el-radio label="2">不限</el-radio>
                  <el-radio label="1">原创</el-radio>
                  <el-radio label="0">转载</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="正负面" prop="emotion">
                <el-radio-group v-model="formSearch.emotion">
                  <el-radio label="-1">不限</el-radio>
                  <el-radio label="51">
                    正面
                    <el-popover
                      placement="top"
                      width="400"
                      trigger="click"
                      popper-class="my-el-popover"
                    >
                      <div class="PorN">
                        <h3>正面值设置</h3>
                        <div class="PorN-progress">
                          <vue-slider
                            v-model="formSearch.emotionValueP"
                            :min="55"
                            :max="100"
                            :width="260"
                            :tooltip="'none'"
                            :dotSize="[8, 8]"
                            :process-style="processStyle"
                          >
                          </vue-slider>
                          <el-input
                            v-model="formSearch.emotionValueP"
                            @blur="onInputBlur('P')"
                            class="PorN-input"
                          ></el-input>
                        </div>
                      </div>
                      <el-button slot="reference" type="text">
                        <i class="el-icon-circle-plus-outline"></i>
                      </el-button>
                    </el-popover>
                  </el-radio>
                  <el-radio label="1"
                    >负面
                    <el-popover
                      placement="top"
                      width="400"
                      trigger="click"
                      popper-class="my-el-popover"
                    >
                      <div class="PorN">
                        <h3>负面值设置</h3>
                        <div class="PorN-progress">
                          <vue-slider
                            v-model="formSearch.emotionValueN"
                            :min="1"
                            :max="45"
                            :width="260"
                            :tooltip="'none'"
                            :dotSize="[8, 8]"
                            :process-style="processStyle"
                          >
                          </vue-slider>
                          <el-input
                            v-model="formSearch.emotionValueN"
                            @blur="onInputBlur('N')"
                            class="PorN-input"
                          ></el-input>
                        </div>
                      </div>
                      <el-button slot="reference" type="text">
                        <i class="el-icon-circle-plus-outline"></i>
                      </el-button>
                    </el-popover>
                  </el-radio>
                  <el-radio label="50">中性</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="情感"
                prop="tagEmotion"
                style="position: relative"
              >
                <!-- <el-checkbox
                  v-model="formSearch.tagEmotionIsAnd"
                  label="切换计算方式"
                  style="position: absolute; right: 10px; top: -37px"
                >
                  切换计算方式
                  <el-tooltip
                    :content="'勾选当前项，搜索结果情感各项将用“并且”方式计算。'"
                    placement="top"
                    effect="light"
                  >
                    <i class="el-icon-warning-outline"></i>
                  </el-tooltip>
                </el-checkbox> -->
                <el-checkbox-group
                  v-model="checkList"
                  @change="handleEmotionSelected"
                >
                  <el-checkbox
                    v-for="item in sidingList"
                    :key="item.id"
                    :label="item.description"
                  >
                    {{ item.value }}
                    <el-popover
                      placement="top"
                      width="180"
                      trigger="click"
                      popper-class="popverClass"
                    >
                      <p class="intervalSetting">情感区间设置</p>
                      <div class="sidingBlock">
                        <el-input
                          v-model="item.sidingStart"
                          size="mini"
                          style="width: 80px"
                        />&nbsp;&nbsp;至&nbsp;&nbsp;<el-input
                          v-model="item.sidingEnd"
                          size="mini"
                          style="width: 80px"
                        />
                      </div>
                      <el-button slot="reference" type="text">
                        <i class="el-icon-circle-plus-outline"></i>
                      </el-button>
                    </el-popover>
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <!-- <el-form-item label="媒体属性" prop="">
                <el-checkbox-group v-model="formSearch.tags">
                  <el-checkbox
                    v-for="item in mediumList"
                    :key="item.id"
                    :label="item.value"
                  >
                    {{ item.name }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item> -->
              <el-form-item label="是否包含图片" prop="haveImage">
                <el-radio-group v-model="haveImage">
                  <el-radio label="-1">不限</el-radio>
                  <el-radio label="1">包含</el-radio>
                  <el-radio label="0">不包含</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否包含视频" prop="haveVideo">
                <el-radio-group v-model="formSearch.haveVideo">
                  <el-radio :label="null">不限</el-radio>
                  <el-radio :label="true">包含</el-radio>
                  <el-radio :label="false">不包含</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- <el-form-item label="文章字数" prop="contentWordsCount">
                <el-radio-group
                  v-model="radioStatus"
                  style="display: flex; flex-direction: column"
                  @change="handlerNumberwords($event)"
                >
                  <el-radio label="1">不限字数</el-radio>
                  <el-radio label="2" style="margin-top: 10px"
                    >从&nbsp;&nbsp;<el-input
                      v-model="NumberStart"
                      size="mini"
                      style="width: 90px"
                    />&nbsp;&nbsp;至&nbsp;&nbsp;<el-input
                      v-model="NumberEnd"
                      size="mini"
                      style="width: 90px"
                    />&nbsp;&nbsp;字</el-radio
                  >
                </el-radio-group>
              </el-form-item> -->
            </div>
            <el-form-item>
              <div class="button-bottom" ref="but">
                <div @click="resetting">重置</div>
                <div @click="handleClose">取消</div>
                <div @click="isClick(formSearch)">确认</div>
              </div>
            </el-form-item>
          </el-form>
          <br />
          <br />
        </div>
      </el-scrollbar>
    </div>
  </el-dialog>
</template>
<script>
import {
  GetProvinceCity,
  GetMedia,
  GetSource,
  GetCustomSourceList,
} from "@/api/index.js";
let moment = require("moment"); // 引入moment
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    moreSearch: {
      type: Object,
      required: true,
    },
    timeType: {
      type: Number,
      default: 0,
    },
  },
  components: {},
  data() {
    return {
      dataType: 0,
      dateTypeList: ["近一月", "近一季", "近一年"],
      labelPosition: "top",
      formSearch: {
        allKey: "",
        anyKey: "",
        exceptKey: "",
        industryTypeId: "0",
        searchResultType: "",
        time: [
          moment().subtract(30, "days").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ],
        searchRange: "",
        releaseSource: "",
        original: null,
        emotion: "-1",
        emotionValueP: 100,
        emotionValueN: 45,
        tagSourceIsAnd: false,
        groupArticletypes: [],
        articletypes: [],
        cityids: [],
        sourceids: [],
        mediaids: [],
        customSourceIds: [],
        imageCount: null,
        haveVideo: null,
        tagEmotion: [],
        tagEmotionIsAnd: false,
        tags: [],
        contentWordsCount: "",
        classify: [],
      },
      //是否包含图片
      haveImage: "-1",
      //原创or转载
      origin: "2",
      //分类
      Allcheck: true,
      classifyCheckList: [],
      classifyList: [
        {
          id: 1,
          description: "社会",
        },
        {
          id: 2,
          description: "教育",
        },
        {
          id: 3,
          description: "时政",
        },
        {
          id: 4,
          description: "经济",
        },
        {
          id: 5,
          description: "军事",
        },
        {
          id: 6,
          description: "科技",
        },
        {
          id: 7,
          description: "体育",
        },
        {
          id: 8,
          description: "艺术",
        },
        {
          id: 9,
          description: "交通",
        },
        {
          id: 10,
          description: "娱乐",
        },
        {
          id: 11,
          description: "汽车",
        },
        {
          id: 12,
          description: "房产",
        },
        {
          id: 13,
          description: "天气",
        },
        {
          id: 14,
          description: "旅游",
        },
        {
          id: 15,
          description: "美食",
        },
        {
          id: 16,
          description: "健康",
        },
        {
          id: 17,
          description: "数码",
        },
      ],

      //情感
      sidingList: [
        {
          id: 1,
          description: "1621",
          value: "乐",
          sidingStart: "50",
          sidingEnd: "999",
        },
        {
          id: 2,
          description: "1622",
          value: "好",
          sidingStart: "50",
          sidingEnd: "999",
        },
        {
          id: 3,
          description: "1623",
          value: "怒",
          sidingStart: "50",
          sidingEnd: "999",
        },
        {
          id: 4,
          description: "1624",
          value: "哀",
          sidingStart: "50",
          sidingEnd: "999",
        },
        {
          id: 5,
          description: "1625",
          value: "惧",
          sidingStart: "50",
          sidingEnd: "999",
        },
        {
          id: 6,
          description: "1626",
          value: "恶",
          sidingStart: "50",
          sidingEnd: "999",
        },
        {
          id: 7,
          description: "1627",
          value: "惊",
          sidingStart: "50",
          sidingEnd: "999",
        },
      ],
      checkList: [],

      //文章字数
      radioStatus: "1",
      NumberStart: "",
      NumberEnd: "",

      //页面显示
      showModel: "SearchCondition",

      //城市选择
      isShowlevelCity: false,
      onelevelCity: [],
      twolevelCity: [],
      //已选中城市
      SelectedCityList: [],
      activeName: "first",
      //正负面
      processStyle: {
        background: "#5386d7",
        marginLeft: "-5px",
      },
      //媒体属性
      mediumList: [
        {
          id: 1,
          value: "1302",
          name: "官方媒体",
        },
        {
          id: 2,
          value: "1303",
          name: "政府类",
        },
        {
          id: 3,
          value: "1304",
          name: "企业类",
        },
        {
          id: 4,
          value: "1305",
          name: "中央级",
        },
        {
          id: 5,
          value: "1306",
          name: "升省级",
        },
        {
          id: 6,
          value: "1307",
          name: "地级级",
        },
        {
          id: 7,
          value: "1308",
          name: "区县级",
        },
        {
          id: 8,
          value: "1309",
          name: "网信办白名单",
        },
      ],
      //来源类型
      AllcheckSource: true,
      sourceList: [
        // {
        //   id: 1,
        //   name: "报纸",
        //   value: 1,
        // },
        {
          id: 2,
          name: "网站",
          value: 2,
        },
        {
          id: 3,
          name: "微信",
          value: 3,
        },
        // {
        //   id: 4,
        //   name: "微博",
        //   value: 4,
        // },
        {
          id: 5,
          name: "客户端",
          value: 5,
        },
        // {
        //   id: 6,
        //   name: "论坛",
        //   value: 6,
        // },
        // {
        //   id: 9,
        //   name: "第三方入驻媒体号",
        //   value: 9,
        // },
      ],
      sourceDetailsList: [
        {
          id: 1,
          name: "都市类报纸",
          value: "newscity",
        },
        {
          id: 2,
          name: "党报类报纸",
          value: "newsgov",
        },
        {
          id: 3,
          name: "专业类报纸",
          value: "newsprofession",
        },
        {
          id: 4,
          name: "媒体类网站",
          value: "website",
        },
        {
          id: 5,
          name: "政府类网站",
          value: "webgov",
        },
        {
          id: 6,
          name: "专业类网站",
          value: "webprofession",
        },
        {
          id: 7,
          name: "博客类网站",
          value: "webboke",
        },
        {
          id: 8,
          name: "新闻类APP",
          value: "webapp",
        },
        {
          id: 9,
          name: "政府类APP",
          value: "webappgov",
        },
        {
          id: 10,
          name: "专业类APP",
          value: "webappprofession",
        },
        {
          id: 11,
          name: "社区类APP",
          value: "webappcommu",
        },
        {
          id: 12,
          name: "媒体类bbs",
          value: "webbbs",
        },
        {
          id: 13,
          name: "专业类bbs",
          value: "webbbsprofession",
        },
        {
          id: 14,
          name: "媒体类微信",
          value: "weixin",
        },
        {
          id: 15,
          name: "政府类微信",
          value: "weixingov",
        },
        {
          id: 16,
          name: "企业类微信",
          value: "weixinentprise",
        },
        {
          id: 17,
          name: "专业类微信",
          value: "weixinprofession",
        },
        {
          id: 18,
          name: "自媒体类微信",
          value: "weixinpersonalmedia",
        },
        {
          id: 19,
          name: "媒体类微博",
          value: "weibo",
        },
        {
          id: 20,
          name: "政府类微博",
          value: "weibogov",
        },
        {
          id: 21,
          name: "企业类微博",
          value: "weiboentprise",
        },
        {
          id: 22,
          name: "专业类微博",
          value: "weiboprofession",
        },
        {
          id: 23,
          name: "自媒体类微博",
          value: "weibopersonalmedia",
        },
        {
          id: 24,
          name: "媒体类头条号",
          value: "mpaccount_jrtt",
        },
        {
          id: 25,
          name: "其他类头条号",
          value: "mpaccount_jrtto",
        },
        {
          id: 26,
          name: "媒体类企鹅号",
          value: "mpaccount_tecent",
        },
        {
          id: 27,
          name: "其他类企鹅号",
          value: "mpaccount_tecento",
        },
        {
          id: 28,
          name: "媒体类一点号",
          value: "mpaccount_yidian",
        },
        {
          id: 29,
          name: "媒体类网易号",
          value: "mpaccount_wangyi",
        },
        {
          id: 30,
          name: "媒体类时间号",
          value: "mpaccount_time",
        },
        {
          id: 31,
          name: "媒体类一直播",
          value: "mpaccount_yizibo",
        },
        {
          id: 32,
          name: "媒体类红豆live客户端",
          value: "mpaccount_hongdoulive",
        },
        {
          id: 33,
          name: "媒体类搜狐号",
          value: "mpaccount_sohu",
        },
        {
          id: 34,
          name: "媒体类其他入驻号",
          value: "mpaccount_other",
        },
        {
          id: 35,
          name: "其他类其他入驻号",
          value: "mpaccount_othero",
        },
      ],
      //范围选择(媒体)
      mediumRangeList: [],
      SelectedmediumRangeList: [],
      mediumSearchKey: "",
      Mediumload: false,
      //范围选择(数据源)
      groupvalue: "",
      groupList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "website",
          label: "网站",
        },
        {
          value: "weibo",
          label: "微博",
        },
        {
          value: "weixin",
          label: "微信",
        },
        {
          value: "news",
          label: "报纸",
        },
        {
          value: "webapp",
          label: "客户端",
        },
        {
          value: "webbbs",
          label: "论坛",
        },
      ],
      datasourceList: [],
      SelectedDatasourceList: [],
      datasourceSearchKey: "",
      datasourceload: false,
      //范围选择(信源)
      infosourceList: [],
      SelectedInfosourceList: [],
      infosourceload: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        },
      },
    };
  },
  activated() {},
  computed: {
    startTime() {
      return Array.isArray(this.formSearch.time) &&
        this.formSearch.time.length === 2
        ? moment(this.formSearch.time[0]).format("YYYY-MM-DD")
        : "";
    },
    endTime() {
      return Array.isArray(this.formSearch.time) &&
        this.formSearch.time.length === 2
        ? moment(this.formSearch.time[1]).format("YYYY-MM-DD")
        : "";
    },
  },
  watch: {
    dialogVisible: {
      handler(newVal, oldVal) {
        if (newVal) {
          // this.formSearch.allKey = this.moreSearch.allKey
          // this.formSearch.time = this.moreSearch.time
          // this.formSearch.groupArticletypes = this.moreSearch.groupArticletypes
          this.formSearch = this.moreSearch;
          this.dataType = this.timeType;
        }
      },
    },
    sidingList: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.handleEmotionSelected();
        }
      },
      immediate: true,
      deep: true,
    },
    NumberStart: {
      handler(newVal, oldVal) {
        if (newVal) {
          if (this.NumberStart == "" && this.NumberEnd == "") {
            this.radioStatus = "1";
            this.$set(this.formSearch, "contentWordsCount", "");
          } else {
            this.radioStatus = "2";
            let a = { from: this.NumberStart, to: this.NumberEnd };
            this.$set(this.formSearch, "contentWordsCount", a);
          }
        }
      },
    },
    NumberEnd: {
      handler(newVal, oldVal) {
        if (newVal) {
          if (this.NumberStart == "" && this.NumberEnd == "") {
            this.radioStatus = "1";
            this.$set(this.formSearch, "contentWordsCount", "");
          } else {
            this.radioStatus = "2";
            let a = { from: this.NumberStart, to: this.NumberEnd };
            this.$set(this.formSearch, "contentWordsCount", a);
          }
        }
      },
    },
    Allcheck: {
      handler(newVal, oldVal) {
        if (newVal) {
          if (newVal == true) {
            this.classifyCheckList = [];
            this.$set(this.formSearch, "classify", []);
          }
        }
      },
    },
    AllcheckSource: {
      handler(newVal, oldVal) {
        if (newVal) {
          if (newVal == true) {
            this.groupArticletypes = [];
            this.$set(this.formSearch, "groupArticletypes", []);
            this.articletypes = [];
            this.$set(this.formSearch, "articletypes", []);
          }
        }
      },
    },
    haveImage: {
      handler(newVal, oldVal) {
        if (newVal) {
          if (newVal == "-1") {
            this.$set(this.formSearch, "imageCount", null);
          } else if (newVal == "1") {
            let imageCount = {
              from: 1,
              to: 10000,
            };
            this.$set(this.formSearch, "imageCount", imageCount);
          } else if (newVal == "0") {
            let imageCount = {
              from: 0,
              to: 0,
            };
            this.$set(this.formSearch, "imageCount", imageCount);
          }
        }
      },
    },
    origin: {
      handler(newVal, oldVal) {
        if (newVal) {
          if (newVal == "2") {
            this.$set(this.formSearch, "original", null);
          } else if (newVal == "1") {
            let original = {
              from: 1,
              to: 9,
            };
            this.$set(this.formSearch, "original", original);
          } else if (newVal == "0") {
            let original = {
              from: 10,
              to: 99,
            };
            this.$set(this.formSearch, "original", original);
          }
        }
      },
    },
    SelectedCityList: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formSearch.cityids = [];
          this.SelectedCityList.map((item) => {
            this.formSearch.cityids.push(item.cityID);
          });
        }
      },
      immediate: true,
      deep: true,
    },
    SelectedmediumRangeList: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formSearch.mediaids = [];
          this.SelectedmediumRangeList.map((item) => {
            this.formSearch.mediaids.push({
              mediaid: item.mediaid,
              mediatype: item.mediatype,
            });
          });
        }
      },
      immediate: true,
      deep: true,
    },
    SelectedDatasourceList: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formSearch.sourceids = [];
          this.SelectedDatasourceList.map((item) => {
            this.formSearch.sourceids.push(item.mediaid);
          });
        }
      },
      immediate: true,
      deep: true,
    },
    SelectedInfosourceList: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formSearch.customSourceIds = [];
          this.SelectedInfosourceList.map((item) => {
            this.formSearch.customSourceIds.push(item.customSourceId);
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.getDefaultTime();
  },
  mounted() {
    // const that = this;
    // setTimeout(() => {
    //   that.$refs.but.style.left = "0px";
    // }, 20);
    this.reorder();
    this.searchMedium("infosource");
  },
  methods: {
    handleClose() {
      // this.resetting()
      this.$emit("closeDialogVisible");
    },
    //检索结果
    isClick(formName, type) {
      if (formName.allKey == "") {
        this.$message({
          message: "请输入搜索词",
          type: "warning",
        });
      } else {
        // 清空其他值
        // if (this.formSearch.industryTypeId === '0') {
        //   this.formSearch.anyKey = ""
        //   this.formSearch.exceptKey = ""
        //   this.formSearch.searchResultType = ""
        //   this.formSearch.time = []
        //   this.formSearch.searchRange = ""
        //   this.formSearch.releaseSource = ""
        //   this.formSearch.original = null
        //   this.formSearch.emotion = "-1"
        //   this.formSearch.emotionValueP = 100
        //   this.formSearch.emotionValueN = 45
        //   this.formSearch.tagSourceIsAnd = false
        //   this.formSearch.groupArticletypes = []
        //   this.formSearch.articletypes= []
        //   this.formSearch.cityids= []
        //   this.formSearch.sourceids= []
        //   this.formSearch.mediaids= []
        //   this.formSearch.customSourceIds= []
        //   this.formSearch.imageCount= null
        //   this.formSearch.haveVideo= null
        //   this.formSearch.tagEmotion= []
        //   this.formSearch.tagEmotionIsAnd= false
        //   this.formSearch.tags= []
        //   this.formSearch.contentWordsCount= ""
        //   this.formSearch.classify= []
        // }
        if (this.formSearch.industryTypeId !== "0") {
          this.formSearch.searchResultType = "";
        }
        if (this.formSearch.groupArticletypes.length === 0) {
          this.$message({
            message: "请勾选数据类型！",
            type: "warning",
          });
          return false;
        }
        // 选中时间类型
        this.formSearch.dataType = this.dataType;
        console.log(this.formSearch);
        this.$emit("handleMoreSet", this.formSearch);
      }
    },
    // 切换日期范围
    changeDate(type, index) {
      this.dataType = index;
      let time = [];
      if (type === "近一月") {
        time = [
          moment().subtract(30, "days").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ];
      } else if (type === "近一季") {
        time = [
          moment().subtract(90, "days").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ];
      } else if (type === "近一年") {
        time = [
          moment().subtract(365, "days").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ];
      }
      this.formSearch.time = time;
    },
    //重置表单
    resetting() {
      (this.formSearch = {
        allKey: "",
        anyKey: "",
        industryTypeId: "0",
        exceptKey: "",
        time: [],
        searchRange: "",
        releaseSource: "",
        original: null,
        // emotion: null,
        emotion: "-1",
        emotionValueP: 100,
        emotionValueN: 45,
        tagSourceIsAnd: false,
        groupArticletypes: [],
        articletypes: [],
        cityids: [],
        sourceids: [],
        mediaids: [],
        customSourceIds: [],
        imageCount: null,
        haveVideo: null,
        tagEmotion: [],
        tagEmotionIsAnd: false,
        tags: [],
        contentWordsCount: null,
        classify: [],
      }),
        (this.haveImage = "-1");
      this.origin = "2";
      this.Allcheck = true;
      this.classifyCheckList = [];
      this.checkList = [];
      this.radioStatus = "1";
      this.NumberStart = "";
      this.NumberEnd = "";
      this.AllcheckSource = true;
      this.SelectedCityList = [];
      this.mediumRangeList = [];
      this.SelectedmediumRangeList = [];
      this.mediumSearchKey = "";
      this.groupvalue = "";
      this.datasourceList = [];
      this.SelectedDatasourceList = [];
      this.datasourceSearchKey = "";
      (this.infosourceList = []),
        (this.SelectedInfosourceList = []),
        (this.sidingList = [
          {
            id: 1,
            description: "1621",
            value: "乐",
            sidingStart: "50",
            sidingEnd: "999",
          },
          {
            id: 2,
            description: "1622",
            value: "好",
            sidingStart: "50",
            sidingEnd: "999",
          },
          {
            id: 3,
            description: "1623",
            value: "怒",
            sidingStart: "50",
            sidingEnd: "999",
          },
          {
            id: 4,
            description: "1624",
            value: "哀",
            sidingStart: "50",
            sidingEnd: "999",
          },
          {
            id: 5,
            description: "1625",
            value: "惧",
            sidingStart: "50",
            sidingEnd: "999",
          },
          {
            id: 6,
            description: "1626",
            value: "恶",
            sidingStart: "50",
            sidingEnd: "999",
          },
          {
            id: 7,
            description: "1627",
            value: "惊",
            sidingStart: "50",
            sidingEnd: "999",
          },
        ]),
        this.getDefaultTime();
      this.clearCity();
      this.searchMedium("infosource");
    },

    //选择情感值
    handleEmotionSelected() {
      let newarr = [];
      this.sidingList.map((item) => {
        const obj = this.checkList.find((value) => value == item.description);
        if (obj) {
          newarr.push(item);
        }
      });
      let resultArr = [];
      if (newarr.length > 0) {
        newarr.map((item) => {
          resultArr.push({
            name: item.description,
            from: item.sidingStart,
            to: item.sidingEnd,
          });
        });
      }
      this.$set(this.formSearch, "tagEmotion", resultArr);
    },
    //选择分类
    handleClassifySelected(val) {
      let newArr = [];
      if (this.classifyCheckList.length > 0) {
        this.Allcheck = false;
        this.classifyCheckList.map((item) => {
          newArr.push(item);
        });
        this.$set(this.formSearch, "classify", newArr);
      } else {
        this.Allcheck = true;
        this.$set(this.formSearch, "classify", []);
      }
    },
    handlerAllcheck(type) {
      if (type == "classify") {
        if (this.classifyCheckList.length == 0) {
          this.Allcheck = true;
        }
      } else if (type == "source") {
        if (this.formSearch.tagSourceIsAnd == false) {
          if (this.formSearch.groupArticletypes.length == 0) {
            this.AllcheckSource = true;
          }
        } else if (this.formSearch.tagSourceIsAnd == true) {
          if (this.formSearch.groupArticletypes.length == 0) {
            this.AllcheckSource = true;
          }
        }
      }
    },
    //来源类型
    handleSourceSelected() {
      if (this.formSearch.groupArticletypes.length > 0) {
        this.AllcheckSource = false;
      } else {
        this.AllcheckSource = true;
        this.$set(this.formSearch, "groupArticletypes", []);
      }
    },
    handleSourceDetailSelected() {
      if (this.formSearch.articletypes.length > 0) {
        this.AllcheckSource = false;
      } else {
        this.AllcheckSource = true;
        this.$set(this.formSearch, "articletypes", []);
      }
    },
    //不限制字数
    handlerNumberwords(val) {
      if (val == 1) {
        this.NumberStart = "";
        this.NumberEnd = "";
        this.$set(this.formSearch, "contentWordsCount", "");
      } else if (val == 2) {
        if (this.NumberStart == "") {
          this.NumberStart = "0";
        }
        if (this.NumberEnd == "") {
          this.NumberEnd = "10000000";
        }
        let a = { from: this.NumberStart, to: this.NumberEnd };
        this.$set(this.formSearch, "contentWordsCount", a);
      }
    },
    //设置默认时间 7天
    getDefaultTime() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      this.formSearch.time[0] = start;
      this.formSearch.time[1] = end;
    },
    //排序方法
    compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value2 - value1;
      };
    },
    //获取全部城市
    reorder() {
      GetProvinceCity()
        .then((res) => {
          this.onelevelCity = res.data;
          var municipalities = [
            "上海",
            "北京",
            "重庆",
            "天津",
            "澳门",
            "香港",
            "海外",
          ];
          for (var i = 0; i < this.onelevelCity.length; i++) {
            if (municipalities.indexOf(this.onelevelCity[i].name) > -1) {
              this.onelevelCity[i].municipalities = 1; //做区分
              this.onelevelCity[i].seleted = false;
              this.onelevelCity[i].cityID = this.onelevelCity[i].children[0].id;
            } else {
              this.onelevelCity[i].municipalities = 0; //做区分
              this.onelevelCity[i].seleted = false;
            }
          }
          this.onelevelCity = this.onelevelCity.sort(
            this.compare("municipalities"),
          );
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    //点击选择城市
    chooseOneCity(item, index) {
      if (item.municipalities == 0) {
        this.isShowlevelCity = true;
        //获取对应下的二级城市
        this.twolevelCity = item.children.map((v, index) => {
          return {
            ...v,
            seleted: false,
            provincename: item.name,
            cityID: v.id,
            city: v.name,
          };
        });
        this.twolevelCity.map((ite) => {
          let find = this.SelectedCityList.find((i) => i.cityID == ite.cityID);
          if (find) {
            ite.seleted = true;
          }
        });
      } else if (item.municipalities == 1) {
        item.seleted = true;
        let find = this.SelectedCityList.find((i) => i.cityID == item.cityID);
        if (!find) {
          this.SelectedCityList.push({
            cityID: item.cityID,
            city: item.name,
          });
        }
      }
    },
    chooseTwoCity(item, index) {
      item.seleted = true;
      let find = this.SelectedCityList.find((i) => i.cityID == item.cityID);
      if (!find) {
        this.SelectedCityList.push({
          cityID: item.cityID,
          city: item.city,
          provincename: item.provincename,
        });
      }
    },
    //移除所选城市
    removeCity(item) {
      this.SelectedCityList = this.SelectedCityList.filter((it) => {
        return it.cityID != item.cityID;
      });
      this.onelevelCity.find((it) => {
        if (it.cityID == item.cityID) {
          it.seleted = false;
        }
      });
      this.twolevelCity.find((it) => {
        if (it.cityID == item.cityID) {
          it.seleted = false;
        }
      });
      this.onelevelCity.map((ite) => {
        if (ite.municipalities == 0) {
          let find = this.SelectedCityList.find(
            (i) => i.provincename == ite.name,
          );
          if (find) {
            ite.seleted = true;
          } else {
            ite.seleted = false;
          }
        }
      });
    },
    //添加全部城市
    addAllCity() {
      let newList = [];
      this.twolevelCity = this.twolevelCity.map((v, index) => {
        return { ...v, seleted: true };
      });
      newList = [...this.SelectedCityList, ...this.twolevelCity];
      this.SelectedCityList = this.objectUnique(newList, "cityID");
    },
    //城市返回上一级
    backuplevel() {
      this.isShowlevelCity = false;
      this.onelevelCity.map((ite) => {
        if (ite.municipalities == 0) {
          let find = this.SelectedCityList.find(
            (i) => i.provincename == ite.name,
          );
          if (find) {
            ite.seleted = true;
          } else {
            ite.seleted = false;
          }
        }
      });
    },
    //清空已选择城市
    clearCity() {
      this.SelectedCityList = [];
      this.onelevelCity.map((ite) => {
        if (ite.municipalities == 0) {
          let find = this.SelectedCityList.find(
            (i) => i.provincename == ite.name,
          );
          if (find) {
            ite.seleted = true;
          } else {
            ite.seleted = false;
          }
        } else if (ite.municipalities == 1) {
          let find = this.SelectedCityList.find((i) => i.cityID == ite.cityID);
          if (find) {
            ite.seleted = true;
          } else {
            ite.seleted = false;
          }
        }
      });
    },
    //正负面空格失去焦点事件
    onInputBlur(type) {
      if (type == "P") {
        if (this.formSearch.emotionValueP < 55) {
          this.formSearch.emotionValueP = 55;
        } else if (this.formSearch.emotionValueP > 100) {
          this.formSearch.emotionValueP = 100;
        }
      } else if (type == "N") {
        if (this.formSearch.emotionValueN < 0) {
          this.formSearch.emotionValueN = 0;
        } else if (this.formSearch.emotionValueN > 45) {
          this.formSearch.emotionValueN = 45;
        }
      }
    },
    //来源类型切换详细
    handlerSourceDetails(val) {
      this.$set(this.formSearch, "groupArticletypes", []);
      this.$set(this.formSearch, "articletypes", []);
      this.AllcheckSource = true;
    },
    //范围选择 搜索
    searchMedium(type) {
      if (type == "mediumRange") {
        this.Mediumload = true;
        GetMedia({ searchkey: this.mediumSearchKey })
          .then((res) => {
            this.mediumRangeList = res.data;
            this.Mediumload = false;
          })
          .catch((err) => {
            console.warn(err);
          });
      } else if (type == "dataSource") {
        this.datasourceload = true;
        GetSource({
          searchkey: this.datasourceSearchKey,
          grouparticletype: this.groupvalue,
        })
          .then((res) => {
            this.datasourceList = res.data;
            this.datasourceload = false;
          })
          .catch((err) => {
            console.warn(err);
          });
      } else if (type == "infosource") {
        this.infosourceload = true;
        GetCustomSourceList()
          .then((res) => {
            this.infosourceList = res.data;
            this.infosourceload = false;
          })
          .catch((err) => {
            console.warn(err);
          });
      }
    },
    choosedmedium(item, type) {
      if (type == "mediumRange") {
        this.mediumRangeList = this.mediumRangeList.filter((it) => {
          return it.mediaid != item.mediaid;
        });
        let find = this.SelectedmediumRangeList.find(
          (i) => i.mediaid == item.mediaid,
        );
        if (!find) {
          this.SelectedmediumRangeList.push({
            grouparticletype: item.grouparticletype,
            mediatype: item.mediatype,
            mediaid: item.mediaid,
            name: item.name,
            typename: item.typename,
          });
        }
        if (this.SelectedmediumRangeList.length >= 50) {
          this.$refs.resultmedium.style.pointerEvents = "none";
          this.$refs.resultmedium.style.opacity = "0.4";
        }
      } else if (type == "dataSource") {
        this.datasourceList = this.datasourceList.filter((it) => {
          return it.mediaid != item.mediaid;
        });
        let find = this.SelectedDatasourceList.find(
          (i) => i.mediaid == item.mediaid,
        );
        if (!find) {
          this.SelectedDatasourceList.push({
            grouparticletype: item.grouparticletype,
            mediatype: item.mediatype,
            mediaid: item.mediaid,
            name: item.name,
            typename: item.typename,
          });
        }
        if (this.SelectedDatasourceList.length >= 50) {
          this.$refs.datasource.style.pointerEvents = "none";
          this.$refs.datasource.style.opacity = "0.4";
        }
      } else if (type == "infosource") {
        this.infosourceList = this.infosourceList.filter((it) => {
          return it.customSourceId != item.customSourceId;
        });
        let find = this.SelectedInfosourceList.find(
          (i) => i.customSourceId == item.customSourceId,
        );
        if (!find) {
          this.SelectedInfosourceList.push({
            createTime: item.createTime,
            createUserName: item.createUserName,
            customSourceId: item.customSourceId,
            customSourceName: item.customSourceName,
            departId: item.departId,
          });
        }
        if (this.SelectedInfosourceList.length >= 50) {
          this.$refs.infosource.style.pointerEvents = "none";
          this.$refs.infosource.style.opacity = "0.4";
        }
      }
    },
    //移除所选范围
    removeMedium(item, type) {
      if (type == "mediumRange") {
        this.SelectedmediumRangeList = this.SelectedmediumRangeList.filter(
          (it) => {
            return it.mediaid != item.mediaid;
          },
        );
        let find = this.mediumRangeList.find((i) => i.mediaid == item.mediaid);
        if (!find) {
          this.mediumRangeList.unshift({
            grouparticletype: item.grouparticletype,
            mediatype: item.mediatype,
            mediaid: item.mediaid,
            name: item.name,
            typename: item.typename,
          });
        }
        if (this.SelectedmediumRangeList.length < 50) {
          this.$refs.resultmedium.style.pointerEvents = "auto";
          this.$refs.resultmedium.style.opacity = "1";
        }
      } else if (type == "dataSource") {
        this.SelectedDatasourceList = this.SelectedDatasourceList.filter(
          (it) => {
            return it.mediaid != item.mediaid;
          },
        );
        let find = this.datasourceList.find((i) => i.mediaid == item.mediaid);
        if (!find) {
          this.datasourceList.unshift({
            grouparticletype: item.grouparticletype,
            mediatype: item.mediatype,
            mediaid: item.mediaid,
            name: item.name,
            typename: item.typename,
          });
        }
        if (this.SelectedDatasourceList.length < 50) {
          this.$refs.datasource.style.pointerEvents = "auto";
          this.$refs.datasource.style.opacity = "1";
        }
      } else if (type == "infosource") {
        this.SelectedInfosourceList = this.SelectedInfosourceList.filter(
          (it) => {
            return it.customSourceId != item.customSourceId;
          },
        );
        let find = this.infosourceList.find(
          (i) => i.customSourceId == item.customSourceId,
        );
        if (!find) {
          this.infosourceList.unshift({
            createTime: item.createTime,
            createUserName: item.createUserName,
            customSourceId: item.customSourceId,
            customSourceName: item.customSourceName,
            departId: item.departId,
          });
        }
        if (this.SelectedInfosourceList.length < 50) {
          this.$refs.infosource.style.pointerEvents = "auto";
          this.$refs.infosource.style.opacity = "1";
        }
      }
    },
    //清空范围
    clearRange(activeName) {
      if (activeName == "first") {
        this.mediumRangeList = [];
        this.SelectedmediumRangeList = [];
        this.$refs.resultmedium.style.pointerEvents = "auto";
        this.$refs.resultmedium.style.opacity = "1";
      } else if (activeName == "second") {
        this.datasourceList = [];
        this.SelectedDatasourceList = [];
        this.$refs.datasource.style.pointerEvents = "auto";
        this.$refs.datasource.style.opacity = "1";
      } else if (activeName == "third") {
        this.SelectedInfosourceList = [];
        this.searchMedium("infosource");
        this.$refs.infosource.style.pointerEvents = "auto";
        this.$refs.infosource.style.opacity = "1";
      }
    },
    //对象按字段去重
    objectUnique(arr, name) {
      var _hash = {};
      return arr.reduce(function (item, _next) {
        _hash[_next[name]] && _next[name]
          ? ""
          : (_hash[_next[name]] = true && item.push(_next));
        return item;
      }, []);
    },
    //精准搜索选择
    handleRadio(e) {
      e === this.formSearch.searchResultType
        ? (this.formSearch.searchResultType = "")
        : (this.formSearch.searchResultType = e);
    },
  },
};
</script>
<style lang="scss">
* {
  list-style: none;
}
.button-bottom {
  // position: fixed;
  // bottom: 0;
  width: 450px;
  border-top: var(--border-color) 1px solid;
  background: #fff;
  // height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  margin-left: -15px;
  margin-top: 30px;
  div {
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid var(--brand);
    width: 30%;
    line-height: 30px;
    text-align: center;
    font-size: 14px;
    color: var(--brand);
    cursor: pointer;
  }
  div:nth-child(3) {
    background: var(--brand) !important;
    color: #fff !important;
  }
}
.againsearch {
  display: flex;
  padding: 8px 15px;
  margin: 0 15px;
  background: #f4f6f8;
  border-radius: 4px;
  justify-content: space-between;
  align-items: baseline;
  p {
    padding-right: 10px;
  }
}
.search-box {
  padding: 0;
  position: relative;
}
//选择城市
.choosedcontent {
  height: 150px;
  cursor: pointer;
  border: 1px dashed #ccc;
  margin-left: 0px;
  .addcity,
  .addIncludeRange {
    height: 150px;
    cursor: pointer;
    line-height: 150px;
    text-align: center;
    font-size: 18px;
    color: #a5b6c7;
    box-sizing: content-box;
    position: relative;
    ul {
      display: flex;
      flex-wrap: wrap;
      padding: 10px 15px 30px 15px;
      overflow: hidden;
      li {
        color: #fff;
        margin: 3px 6px;
        cursor: pointer;
        height: 28px;
        line-height: 28px;
        background: #5386d7;
        font-size: 12px;
        border-radius: 3px;
        p {
          padding: 0px 5px;
        }
        p:hover {
          background: rgba(255, 255, 255, 0.1);
        }
      }
    }
  }
}
.el-popover.my-el-popover {
  padding: 0px !important;
  //城市
  .citylist,
  .mediumList {
    h3 {
      padding: 8px 14px;
      margin: 0;
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      background-color: #f7f7f7;
      border-bottom: 1px solid #ebebeb;
      border-radius: 5px 5px 0 0;
    }
    .oneCity,
    .twoCity {
      display: flex;
      flex-wrap: wrap;
      padding: 10px 15px 30px 15px;
      overflow: hidden;
      li {
        color: #326699;
        text-decoration: none;
        margin: 3px 6px;
        cursor: pointer;
        a {
          padding: 3px 5px;
          display: inline-block;
          border-radius: 3px;
          color: #3a5a7a;
          font-size: 12px;
        }
      }
      .chooseactive {
        background: #5386d7;
        color: #fff;
      }
    }
    .btn-city {
      padding: 10px 15px 20px 15px;
      float: right;
    }
    .medium-search {
      display: flex;
    }
  }
  //正负面
  .PorN {
    h3 {
      padding: 8px 14px;
      margin: 0;
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      background-color: #f7f7f7;
      border-bottom: 1px solid #ebebeb;
      border-radius: 5px 5px 0 0;
    }
    .PorN-progress {
      display: flex;
      align-items: center;
      padding: 10px 15px;
      .PorN-line {
        width: 143px;
        height: 4px;
        background: rgb(83, 134, 215);
        margin: 0;
        padding: 0;
        border-radius: 15px 0 0 15px;
      }
      .PorN-input {
        width: 60px;
        margin-left: 20px;
      }
    }
  }
  //范围选择
  .result-choosedmedium {
    list-style-type: none;
    border: 1px solid #ccc;
    height: 500px;
    width: 100%;
    padding-left: 0;
    border-radius: 5px;
    font-size: 13px;
    color: #555;
    background: white;
    margin-top: 10px;
    pointer-events: auto;
    opacity: 1;
    li {
      border-bottom: 1px solid #eee;
      padding: 2px 15px;
      line-height: 20px;
      cursor: pointer;
      color: #3a5a7a;
    }
  }
}
.dateType {
  height: 30px;
  line-height: 30px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  div {
    width: 30%;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #82878c;
    cursor: pointer;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    text-align: center;
  }
  .active {
    background: #e9f1f6;
  }
}
.return {
  position: absolute;
  right: 39px;
  top: -48px;
  color: #5386d7;
  font-size: 12px;
  cursor: pointer;
}
</style>
<style lang="scss" scoped>
/deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}
.againsearch-text {
  /deep/ .el-textarea__inner {
    background: #f4f6f8;
    border: none;
    padding-left: 0;
  }
}
</style>
<style>
.more-setting-dialog .el-dialog__body {
  padding: 10px;
}
</style>
